import { createContext } from "react";

export interface IHasErrorContext {
  hasError: boolean;
  error?: unknown;
}

const HasError = createContext<IHasErrorContext>({ hasError: false });

export default HasError;
